import React from 'react';
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Alert,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import FileDropZone from './commun/FileDropZone';

interface CarteArriveeChineComponentProps {
  carteArrivee: string;
  setCarteArrivee: React.Dispatch<React.SetStateAction<string>>;
  // Si true, on n'affiche pas les uploads billet/hôtel (déjà demandés via le motif Tourisme)
  reuseBilletHotel: boolean;
  billetAvionECard: File | null;
  setBilletAvionECard: React.Dispatch<React.SetStateAction<File | null>>;
  pasDeBilletECard: boolean;
  setPasDeBilletECard: React.Dispatch<React.SetStateAction<boolean>>;
  hotelECard: File | null;
  setHotelECard: React.Dispatch<React.SetStateAction<File | null>>;
  pasDeHotelECard: boolean;
  setPasDeHotelECard: React.Dispatch<React.SetStateAction<boolean>>;
}

const CarteArriveeChineComponent: React.FC<CarteArriveeChineComponentProps> = ({
  carteArrivee,
  setCarteArrivee,
  reuseBilletHotel,
  billetAvionECard,
  setBilletAvionECard,
  pasDeBilletECard,
  setPasDeBilletECard,
  hotelECard,
  setHotelECard,
  pasDeHotelECard,
  setPasDeHotelECard,
}) => {
  return (
    <Box
      sx={{
        border: '1px solid #ccc',
        borderRadius: 2,
        p: 2,
        mb: 2,
        backgroundColor: '#f9f9f9',
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
        Carte d'arrivée (e-arrival Card)
      </Typography>

      <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
        Toute entrée en Chine nécessite une carte d'arrivée électronique délivrée
        par les autorités Chinoises. Délivrée sous forme d'un document PDF avec
        QR code, Visa Monde propose l'obtention de cette carte d'arrivée pour 39€.
        Elle vous parviendra par mail et sera disponible dans votre espace client
        à tout moment, après l'obtention du visa Chinois commandé.
      </Typography>

      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel id="carte-arrivee-label">
          Souhaitez-vous confier l'obtention de cette carte par nos services ?
        </InputLabel>
        <Select
          labelId="carte-arrivee-label"
          value={carteArrivee}
          label="Souhaitez-vous confier l'obtention de cette carte par nos services ?"
          onChange={(e) => setCarteArrivee(e.target.value)}
        >
          <MenuItem value="oui">Oui (+ 39€ TTC)</MenuItem>
          <MenuItem value="non">
            Non (Vous devrez obtenir cette carte par vos propres moyens avant votre départ)
          </MenuItem>
        </Select>
      </FormControl>

      {carteArrivee === 'non' && (
        <Alert severity="warning" sx={{ mb: 1 }}>
          <Typography variant="h6">
            La carte d'arrivée est obligatoire pour toute entrée en Chine. Vous
            avez choisi de ne pas nous confier cette tâche, il sera donc
            impératif de l'obtenir par vos propres moyens avant le départ en Chine.
          </Typography>
        </Alert>
      )}

      {carteArrivee === 'oui' && !reuseBilletHotel && (
        <>
          <Box sx={{ mt: 2, mb: 2 }}>
            <FileDropZone
              label="Billet d'avion"
              file={billetAvionECard}
              onFileSelected={setBilletAvionECard}
              accept=".pdf,.jpg,.jpeg,.png"
              disabled={pasDeBilletECard}
            />
            <FormControlLabel
              sx={{ display: 'block', mt: 1 }}
              control={
                <Checkbox
                  checked={pasDeBilletECard}
                  onChange={(e) => {
                    setPasDeBilletECard(e.target.checked);
                    if (e.target.checked) setBilletAvionECard(null);
                  }}
                />
              }
              label="Je n'ai pas encore mon billet d'avion (vous serez contacté par nos services après l'obtention du visa pour les détails)"
            />
          </Box>

          <Box sx={{ mb: 1 }}>
            <FileDropZone
              label="Réservation d'hôtel"
              file={hotelECard}
              onFileSelected={setHotelECard}
              accept=".pdf,.jpg,.jpeg,.png"
              disabled={pasDeHotelECard}
            />
            <FormControlLabel
              sx={{ display: 'block', mt: 1 }}
              control={
                <Checkbox
                  checked={pasDeHotelECard}
                  onChange={(e) => {
                    setPasDeHotelECard(e.target.checked);
                    if (e.target.checked) setHotelECard(null);
                  }}
                />
              }
              label="Je n'ai pas encore réservé mon hôtel (vous serez contacté par nos services après l'obtention du visa pour les détails)"
            />
          </Box>
        </>
      )}
    </Box>
  );
};

export default CarteArriveeChineComponent;
